import { useLocalStorage } from "usehooks-ts";
import { LinkButton } from "#/_packages/umbrella/features/button/components/button.tsx";
import type { IUrl } from "#/_packages/umbrella/features/form-block/types";

interface ICookieNotificationProps {
	body?: string;
	link?: IUrl;
}

const CookieNotification = (props: ICookieNotificationProps) => {
	const [cookies, setCookie] = useLocalStorage<boolean>(
		"user-approved-cookie",
		false,
	);

	const handleClick = () => {
		setCookie(true);
	};

	if (cookies) return;

	return (
		<div className="message-cookies js-message-cookies flex flex-col gap-4">
			{/** biome-ignore lint/security/noDangerouslySetInnerHtml: <explanation> */}
			<div className="rich-text" dangerouslySetInnerHTML={{ __html: props.body ?? "" }}></div>
			<div className="flex gap-3">
				<button
					className="btn btn-light js-btn-cookies"
					onClick={handleClick}
					type="button"
				></button>
				{props.link && (
					<LinkButton intent={"light"} variant={"outline"}>
						{props.link.name}
					</LinkButton>
				)}
			</div>
		</div>
	);
};

CookieNotification.displayName = "CookieNotification";
export default CookieNotification;
